import { render } from "./ProfileView.vue?vue&type=template&id=e587c0de&scoped=true"
import script from "./ProfileView.vue?vue&type=script&lang=js"
export * from "./ProfileView.vue?vue&type=script&lang=js"

import "./ProfileView.css?vue&type=style&index=0&id=e587c0de&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e587c0de"]])

export default __exports__